'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFeaturedPlayList = function AvFeaturedPlayList(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z' })
  );
};
AvFeaturedPlayList = (0, _pure2.default)(AvFeaturedPlayList);
AvFeaturedPlayList.displayName = 'AvFeaturedPlayList';

exports.default = AvFeaturedPlayList;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/av/featured-play-list.js
 ** module id = 1182
 ** module chunks = 0
 **/